import script from "./BookingSuccessModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingSuccessModal.vue?vue&type=script&setup=true&lang=js"

import "./BookingSuccessModal.vue?vue&type=style&index=0&id=06af31c4&scoped=true&lang=scss"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06af31c4"]])

export default __exports__